/**
 * Injects Adalyser Script into the head.
 *
 * @param isEnabled Whether Adalyser is enabled.
 * @param id The Adalyser client ID.
 * @returns The Adalyser script object.
 */
export function injectAdalyser({
  isEnabled,
  id,
}: {
  isEnabled: boolean
  id: string
}) {
  if (!isEnabled) {
    return
  }

  return {
    key: 'adalyser',
    type: 'text/javascript' as const,
    innerHTML: injectAdalyserScript({ id }),
  }
}

/**
 * Generates and returns the actual script content for Adalyser to be
 * injected.
 *
 * @param id The Adalyser client ID.
 * @returns The Adalyser script content.
 */
function injectAdalyserScript({ id }: { id: string }) {
  return `
    (function(clientId) {
      if(window["__adal_disable_" + clientId]) { return; }
      (function(windowAlias, documentAlias, trackerName) {
        if (!windowAlias[trackerName]) {
          windowAlias.GlobalAdalyserNamespace = windowAlias.GlobalAdalyserNamespace || [];
          windowAlias.GlobalAdalyserNamespace.push(trackerName);
          windowAlias[trackerName] = function() {
            (windowAlias[trackerName].q = windowAlias[trackerName].q || []).push(arguments)
          };
          windowAlias[trackerName].q = windowAlias[trackerName].q || [];
          var nel = documentAlias.createElement("script"),
          fel = documentAlias.getElementsByTagName("script")[0];
          nel.async = 1;
          nel.src = "//c5.adalyser.com/adalyser.js?cid=" + clientId;
          fel.parentNode.insertBefore(nel, fel)
        }
      })(window, document, "adalyserTracker");
      window.adalyserTracker("create", {
        campaignCookieTimeout: 15552000,
        conversionCookieTimeout: 604800,
        clientId: clientId,
        trafficSourceInternalReferrers: ["^(.*\\.)?rvezy.*$"],
      });
      window.adalyserTracker("trackSession", "lce1");
    })("${id}");
  `
}
